export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_04.d8178d1e.mp4";